module.exports = __webpack_public_path__ + "static/media/Sell-how.12a38908.mp4";